import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type * as clusters from '../../../../clusters'
import type { Plugin } from '../plugin'

/**
 * Reloads the cluster options whenever clusters are created, renamed or
 * deleted, so that the filter reflects the Clusters page without the user
 * having to reload.
 */
export const reloadOptionsOnClusterChange = store.effects.create(
  (feature: Plugin['feature'], clustersEc: clusters.Collection) =>
    clustersEc.plugins.editingPlugin.feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(action => feature.actions.loadOptions.from(action).create()),
      ),
)
